export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "callStatus": { "inboundCallReceived": "A call was received at {{ historyFormattedTimestamp }}." }, "threadCallStatus": { "inboundCallReceived": "Inbound call received" } } } });
};